import Extension from "../base/extension";

class Nav extends Extension {
  #section;

  data = {
    selectors: {
      navOffcanvas: ".offcanvas",
      navOffcanvasContent: ".nav-offcanvas-content",
      navDesktopItems: "#navbar nav .main-nav.navbar-nav .nav-item.dropdown",
      navDesktopOverlay: ".nav-desktop-overlay"
    }
  }

  constructor(name) {
    super(name);
  }

  init() {
    this.#section = document.querySelector('.section-header-metaobjects');
    this.setupScrollListener();
    document.addEventListener('interaction:down-scroll', this.onScrollDown.bind(this));
    document.addEventListener('interaction:up-scroll', this.onScrollUp.bind(this));
  }

  /* Added a check to change the offcanvas menu size  adjustment for mobile devices only
   * Solves the issue with testing when people switched from desktop to mobile
   * and the offcanvas menu was still the desktop size.
  */
  onReady() {

    /* Show/hide overlay when displaying megamenu */
    document.querySelectorAll(this.data.selectors.navDesktopItems).forEach(e => {
      e.addEventListener('mouseenter', () => {
        document.querySelector(this.data.selectors.navDesktopOverlay).classList.add('show');
      });
      e.addEventListener('mouseleave', () => {
        document.querySelector(this.data.selectors.navDesktopOverlay).classList.remove('show');
      });
    });

    const setOffcanvasWidth = () => {
      const isMobile = window.matchMedia("(max-width: 767px)").matches;
      if (!isMobile) return;

      const offcanvas = document.querySelector(this.data.selectors.navOffcanvas);
      if (!offcanvas) return;

      const offcanvasWidth = offcanvas.getBoundingClientRect().width;
      document.querySelectorAll(this.data.selectors.navOffcanvasContent).forEach(e => {
        e.style.width = `${offcanvasWidth}px`;
      });
    };

    setOffcanvasWidth();

    window.addEventListener("resize", setOffcanvasWidth);
  }

  onScrollDown(e) {
    if(e.detail.difference > 5) {
      this.#section.classList.remove('scrolled-up');
      this.#section.classList.add('scrolled-down');
    }
  }

  onScrollUp(e) {
    if(e.detail.difference > 5) {
      this.#section.classList.remove('scrolled-down');
      this.#section.classList.add('scrolled-up');
    }
  }

  setupScrollListener() {
    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    window.addEventListener("scroll", function(e){
      let st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      let difference = Math.abs(st - lastScrollTop);
      // Add a 'tolerance' to prevent microscrolls from retriggering (e.g. on touch devices, there's usually a very small scroll up after scrolling down)
      if (st > lastScrollTop){
        let event = new CustomEvent("interaction:down-scroll", {
          detail: {
            difference: difference
          }
        });
        document.dispatchEvent(event);
      } else {
        let event = new CustomEvent("interaction:up-scroll", {
          detail: {
            difference: difference
          }
        });
        document.dispatchEvent(event);
      }
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);
  }
}

export default Nav;